const availableLanguages = ['en', 'ro'];

export default availableLanguages;
